var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogoCasaSaenz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 941.3 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #17231d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.9,112.6c-13.3,0-24.1-10.9-24.1-24.2s10.8-24.2,24.1-24.2,13.2,2.9,17.6,7.6l11.6-11.5c-7.3-7.6-17.6-12.2-29-12.2-22.3,0-40.3,18-40.3,40.3s18,40.3,40.3,40.3,21.8-4.8,29.2-12.5l-11.6-11.4c-4.5,4.8-10.8,7.8-17.8,7.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.7,49.2l-28.5,78.4h17.6l6.3-18.7h23.6l6.3,18.7h17.6l-28.4-78.4h-14.3ZM145.1,94l6.8-20.3,6.7,20.3h-13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235,81.5l-15.8-4.7c-3.9-1-6.8-3.8-6.8-6.6s5-7,11-7,12.4,2.5,13.7,9.3l14.8-7.4c-3.2-9.8-14.4-17.1-27.8-17.1s-28.8,10.3-28.8,23.1,7.3,17.7,17.7,21.2l15.6,4.4c4.5,1.3,7.5,4.5,7.5,8.2s-5.5,8.8-12.5,8.8-12.7-4-14-11.1l-15.3,6.7c2.9,11,14.9,19.4,29.2,19.4s29.9-11.1,29.9-24.4-7.5-18.9-18.2-22.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.5,49.2l-28.5,78.4h17.6l6.3-18.7h23.6l6.3,18.7h17.6l-28.4-78.4h-14.3ZM288.9,94l6.8-20.3,6.7,20.3h-13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M580.3,81.5l-15.8-4.7c-3.9-1-6.8-3.8-6.8-6.6s5-7,11-7,12.4,2.5,13.7,9.3l14.8-7.4c-3.2-9.8-14.4-17.1-27.8-17.1s-28.8,10.3-28.8,23.1,7.3,17.7,17.7,21.2l15.6,4.4c4.5,1.3,7.5,4.5,7.5,8.2s-5.5,8.8-12.5,8.8-12.7-4-14-11.1l-15.3,6.7c2.9,11,14.9,19.4,29.2,19.4s29.9-11.1,29.9-24.4-7.5-18.9-18.2-22.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M633.8,49.2l-28.5,78.4h17.6l6.3-18.7h23.6l6.3,18.7h17.6l-28.4-78.4h-14.3,0ZM634.1,94l6.8-20.3,6.7,20.3h-13.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "687.7 127.6 747.5 127.6 747.5 111.9 704 111.9 704 95.9 739.1 95.9 739.1 80.9 704 80.9 704 64.9 747.5 64.9 747.5 49.2 687.7 49.2 687.7 127.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "804.5 49.2 804.5 99.7 776.6 49.2 760.9 49.2 760.9 127.6 777.2 127.6 777.2 77 805 127.6 820.8 127.6 820.7 49.2 804.5 49.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "902.5 49.2 835.4 49.2 835.4 65 879.6 65 835.4 114.2 835.4 127.6 902.5 127.6 902.5 111.8 858.3 111.8 902.5 62.5 902.5 49.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 624.5,
    y: 30.3,
    width: 32.9,
    height: 10.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.7,62.7c-4.8-6.3-12.6-10.7-18.8-15.4-6-4.5-15.1-13.6-22.9-14.1-8.5-.6-17,8.6-23.2,13.3-6.2,4.7-11.1,8.7-15.7,15.1-3.9,5.5-4.5,11.8-5.4,18.2-1.1,7.6-1.8,15.3-2.2,22.9-.3,5.7-2.2,15.4,1.4,20.5,1.5,1.9,3.5,3.3,5.8,3.8,5.4,1.3,10.9,1.9,16.4,2.2,5.2.3,10.4.8,11.3-3.5,1.3-5.9.8-10.3,1.1-17.9.2-4.2,2-14.8,7.9-14.9,14.8-.2,11.7,22,11.8,31.3,0,1.3.3,2.8,1.2,3.8,2.3,2.5,6.1,1.7,9.1,1.3,4.5-.6,9-.9,13.5-2,4.9-1.2,10.3-3.3,13.5-7.5,6.7-8.7,2.9-21.7,2.3-31.6-.5-9-1.4-18-7.1-25.5h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoCasaSaenz);
export default __webpack_public_path__ + "static/media/main-logo-casa-saenz.946439d8a75e3646afefffebc088dd0c.svg";
export { ForwardRef as ReactComponent };